import React, { useEffect } from "react";
import { AiOutlineSafety } from "react-icons/ai";
import useBasketManager from "../hooks/useBasketManager";
import "./style.scss";
import { PaymentLogos } from "../../../../features/PaymentLogo";
import { useTranslation } from "react-i18next";
import EAButton from "../../shared/Buttons/EAButton";

interface IProps {
  eCardPaymnet: Function;
  handleSetPayment: (type: string) => void;
  alert: string;
}

const EcardSummary: React.FC<IProps> = ({ eCardPaymnet, handleSetPayment, alert }: IProps) => {
  const { t } = useTranslation();
  const { getBasket, total, totalListPrice } = useBasketManager();
  useEffect(() => {
    setTimeout(() => {
      getBasket();
    }, 400);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div className="basket-summary">
        <h3>{t("podsumowanie_zamowienia")}</h3>

        <div className="summary-line flex-between-center">
          <span>{t("do_zaplaty")}: </span>
          <b>
            {total.toFixed(2)} {t("zl")}
          </b>
        </div>

        <div className="summary-line promition-line flex-between-center">
          <span>{t("oszczedasz")}:</span>
          <b>
            {(totalListPrice - total).toFixed(2)}
            {t("zl")}
          </b>
        </div>

        {alert.length > 2 && <div className="alert alert-red">{alert}</div>}

        <div className="ecard-summary-buttons">
          <EAButton
            title={t("potwierdz_platnosc_ekarta")}
            onClick={() => eCardPaymnet()}
            fullWidth
            endIcon={<AiOutlineSafety />}
          />

          <p className="or extra-margin">{t("lub")}</p>
          <EAButton
            title={t("wroc_do_platnosci_internetowej")}
            onClick={() => handleSetPayment("online")}
            variant="outlined"
            fullWidth
          />
        </div>

        <PaymentLogos />
      </div>
    </>
  );
};

export default EcardSummary;
